import React from 'react'
import { withRouter } from 'react-router-dom'
import AssetsLiabilities from '../assets-liabilities/AssetsLiabilities'

function Home() {
  return <AssetsLiabilities />
}
export default withRouter(Home)
